export const styles = (isSmallScreen: boolean) => ({
	mb: isSmallScreen ? 4 : 0,
	ml: isSmallScreen ? 0 : 4,
	width: isSmallScreen ? 1 : 'auto',
});
